import { Injectable } from '@angular/core';
import { Translatable } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class GenCartCouponService {
  private error$ = new BehaviorSubject<string | Translatable>(null);

  public getError(): Observable<string | Translatable> {
    return this.error$;
  }

  public addError(text: string | Translatable): void {
    this.error$.next(typeof text === 'string' ? { raw: text } : text);
  }

  public removeError(): void {
    this.error$.next(null);
  }
}
